import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const exportBookingsExcel = (bookings) => {

    if (!bookings || bookings.length === 0) {
        alert("No bookings found");
        return;
    }

    const venue = bookings[0].eventVenue;

    const eventName = venue?.event?.eventName || "";
    const venueName = venue?.venue || "";
    const eventDate = new Date(venue?.date)
        .toLocaleDateString("en-GB")
        .replace(/\//g, "-");

    const adultPrice = venue?.adultTicketPrice || "";
    const childPrice = venue?.childrenTicktPrice || "";
    const convenienceFee = venue?.convenienceFee || "";

    const safeEvent = eventName.replace(/[\\/:*?"<>|]/g, "");
    const safeVenue = venueName.replace(/[\\/:*?"<>|]/g, "");

    const fileName = `UserBookings-${safeEvent}-${safeVenue}-${eventDate}`;

    const data = [];

    /* Row 1 */
    data.push(["Event Name", "Venue",
        "Event Date",
        "Adult Price",
        "Children Price",
        "Convenience Fee"]);

    /* Row 2 */
    data.push([
        eventName,
        venueName,
        eventDate,
        adultPrice,
        childPrice,
        convenienceFee
    ]);

    /* Row 3 empty */
    data.push([]);

    /* Row 4 headers */
    data.push([
        "Sl no",
        "Booking Id",
        "Booking Date",
        "Name",
        "Mobile No",
        "Email",
        "Adult Count",
        "Children Count",
        "Total Amount",
        "Payment Status",
        "City",
        "State",
        "Pincode"
    ]);

    /* Row 6+ data */
    bookings.forEach((b, index) => {

        const bookingDate = new Date(b.createdAt)
            .toLocaleDateString("en-GB")
            .replace(/\//g, "-");

        data.push([
            index + 1,
            b.bookingId,
            bookingDate,
            b.name,
            b.mobileNo,
            b.email,
            b.adultCount,
            b.childrenCount,
            b.totalAmount,
            b.paymentStatus,
            b.city,
            b.state,
            b.pincode
        ]);

    });

    const worksheet = XLSX.utils.aoa_to_sheet(data);

    /* AUTO COLUMN WIDTH */
    const colWidths = data[4].map((_, i) => ({
        wch: Math.max(
            ...data.map(row => (row[i] ? row[i].toString().length : 10))
        )
    }));

    worksheet["!cols"] = colWidths;

    const workbook = XLSX.utils.book_new();

    const sheetName = "Bookings";

    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
    });

    const blob = new Blob([excelBuffer], {
        type: "application/octet-stream"
    });

    saveAs(blob, `${fileName}.xlsx`);
};

export const exportStallBookingsExcel = (bookings) => {

    if (!bookings || bookings.length === 0) {
        alert("No stall bookings found");
        return;
    }

    const venue = bookings[0].eventVenue;

    const eventName = venue?.event?.eventName || "";
    const venueName = venue?.venue || "";
    const eventDate = new Date(venue?.date)
        .toLocaleDateString("en-GB")
        .replace(/\//g, "-");

    const safeEvent = eventName.replace(/[\\/:*?"<>|]/g, "");
    const safeVenue = venueName.replace(/[\\/:*?"<>|]/g, "");

    const fileName = `StallBookings-${safeEvent}-${safeVenue}-${eventDate}`;

    const data = [];

    /* Row 1 */
    data.push(["Event Name", "Venue", "Event Date"]);

    /* Row 2 */
    data.push([
        eventName,
        venueName,
        eventDate
    ]);

    /* Row 3 empty */
    data.push([]);

    /* Row 4 headers */
    data.push([
        "Sl no",
        "Business / Stall Name",
        "Mobile Number",
        "Email",
        "Address",
        "Stall Type",
        "Stall Details",
        "Instagram",
        "Facebook",
        "Social Media Tag"
    ]);

    /* Row 5+ data */
    bookings.forEach((b, index) => {

        data.push([
            index + 1,
            b.userNameOrBusinessName,
            b.mobileNumber,
            b.email,
            b.address,
            b.stallType?.stallType || "",
            b.stallDetails,
            b.instagramLink || "",
            b.fbLink || "",
            b.socialMediaTag ? "Yes" : "No"
        ]);

    });

    const worksheet = XLSX.utils.aoa_to_sheet(data);

    /* AUTO COLUMN WIDTH */
    const colWidths = data[3].map((_, i) => ({
        wch: Math.max(
            ...data.map(row => (row[i] ? row[i].toString().length : 10))
        )
    }));

    worksheet["!cols"] = colWidths;

    const workbook = XLSX.utils.book_new();

    const sheetName = "StallBookings";

    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
    });

    const blob = new Blob([excelBuffer], {
        type: "application/octet-stream"
    });

    saveAs(blob, `${fileName}.xlsx`);

};

export const exportPerformanceBookingsExcel = (bookings) => {

    if (!bookings || bookings.length === 0) {
        alert("No performance bookings found");
        return;
    }

    const venue = bookings[0].eventVenue;

    const eventName = venue?.event?.eventName || "";
    const venueName = venue?.venue || "";
    const eventDate = new Date(venue?.date)
        .toLocaleDateString("en-GB")
        .replace(/\//g, "-");

    const safeEvent = eventName.replace(/[\\/:*?"<>|]/g, "");
    const safeVenue = venueName.replace(/[\\/:*?"<>|]/g, "");

    const fileName = `PerformanceBookings-${safeEvent}-${safeVenue}-${eventDate}`;

    const data = [];

    /* Event Info */
    data.push(["Event Name", "Venue", "Event Date"]);
    data.push([eventName, venueName, eventDate]);

    data.push([]);

    /* Headers */
    data.push([
        "Sl no",
        "Name",
        "Mobile Number",
        "Email",
        "Performance Type",
        "Performance Details",
        "Instagram",
        "Facebook"
    ]);

    bookings.forEach((b, index) => {

        data.push([
            index + 1,
            b.userNameOrBusinessName,
            b.mobileNumber,
            b.email,
            b.performanceType?.performanceType || "",
            b.performanceDetails || "",
            b.instagramLink || "",
            b.fbLink || ""
        ]);

    });

    const worksheet = XLSX.utils.aoa_to_sheet(data);

    const colWidths = data[3].map((_, i) => ({
        wch: Math.max(
            ...data.map(row => (row[i] ? row[i].toString().length : 10))
        )
    }));

    worksheet["!cols"] = colWidths;

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "PerformanceBookings");

    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
    });

    const blob = new Blob([excelBuffer], {
        type: "application/octet-stream"
    });

    saveAs(blob, `${fileName}.xlsx`);

};